export enum UserType {
  Standard = 1,
  Clinician = 5,
}
